import React from 'react';
import 'devextreme/dist/css/dx.light.css';
import AppRouter from './routes/router';
import { DevExtremeModalGlobalStyles } from '../src/shared/estilos.styles';
import 'devextreme/dist/css/dx.light.css'; // o el tema que prefieras, como dx.dark.css
const App: React.FC = () => {
  return (
    <><DevExtremeModalGlobalStyles /><AppRouter /></>
  );
}

export default App;